import React, { SyntheticEvent, useState } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { Grid } from '@mui/material';

import BasicModal from 'components/rootComponents/Modal/BasicModal';
import SearchInput from 'components/rootComponents/Standards/SearchInput/SearchInput';
import { standarizeString } from 'utils/helper';
import './FAQModal.css';

import tarea from 'assets/img/moodle_icons/tarea.png';
import archivo from 'assets/img/moodle_icons/archivo.png';
import asistencia from 'assets/img/moodle_icons/asistencia.png';
import base_de_datos from 'assets/img/moodle_icons/base_de_datos.png';
import carpeta from 'assets/img/moodle_icons/carpeta.png';
import chat from 'assets/img/moodle_icons/chat.png';
import consulta from 'assets/img/moodle_icons/consulta.png';
import cuestionario from 'assets/img/moodle_icons/cuestionario.png';
import eleccion_de_grupo from 'assets/img/moodle_icons/eleccion_de_grupo.png';
import encuesta_2 from 'assets/img/moodle_icons/encuesta_2.png';
import encuesta from 'assets/img/moodle_icons/encuesta.png';
import etiqueta from 'assets/img/moodle_icons/etiqueta.png';
import foro from 'assets/img/moodle_icons/foro.png';
import glosario from 'assets/img/moodle_icons/glosario.png';
import h5p from 'assets/img/moodle_icons/h5p.png';
import herramienta_externa from 'assets/img/moodle_icons/herramienta_externa.png';
import leccion from 'assets/img/moodle_icons/leccion.png';
import libro from 'assets/img/moodle_icons/libro.png';
import lista_de_verificacion from 'assets/img/moodle_icons/lista_de_verificacion.png';
import pagina from 'assets/img/moodle_icons/pagina.png';
import paquete_de_contenido_ims from 'assets/img/moodle_icons/paquete_de_contenido_ims.png';
import paquete_scorm from 'assets/img/moodle_icons/paquete_scorm.png';
import reserva_2 from 'assets/img/moodle_icons/reserva_2.png';
import reserva from 'assets/img/moodle_icons/reserva.png';
import taller from 'assets/img/moodle_icons/taller.png';
import url from 'assets/img/moodle_icons/url.png';
import wiki from 'assets/img/moodle_icons/wiki.png';

interface IFAQData {
  name: string;
  code: string;
  questions: IFAQ[];
}

interface IFAQ {
  Q: string;
  A: string;
}

// List of categories and their FAQ
const ListOfFaQs: IFAQData[] = [
  {
    name: 'Sobre AA',
    code: 'sobre_aa',
    questions: [
      {
        Q: '¿Qué entendemos por Analíticas del Aprendizaje?',
        A: '25.2  millones de resultados proporciona Google cuando buscamos las siguientes palabras claves: analíticas + aprendizaje + definición. La Sociedad de Investigación de Análiticas del Aprendizaje (SoLAR) la define cómo:  La medición, recopilación, análisis y reporte de datos sobre los estudiantes y sus contextos, con el propósito de comprender y optimizar el aprendizaje y los entornos en los que se produce.<br>Esta definición es uno de los pilares en el que nos apoyamos para iniciar y desarrollar este proyecto y desde ese momento somos partidarios que UTEC debe elaborar su propia definición. Si estás de acuerdo y queres participar es escribinos a <a href="mailto:tecnologia.aprendizaje@utec.edu.uy">tecnologia.aprendizaje@utec.edu.uy</a>',
      },
      {
        Q: '¿Qué es Aprendizaje Aumentado?',
        A: 'El Portal Académico, los entornos virtuales (EDU, Moodle), los sistemas de videoconferencia, formularios, etc., son espacios en los que se generan datos minuto a minuto. Recopilar, normalizar, y disponibilizar esos datos  a los actores de la UTEC (docentes, estudiantes y colaboradores) para que sirvan como insumos para la toma de decisiones es el desafío que nos propusimos.<br>Aprendizaje Aumentado es la aplicación  desarrollada por UTEC que  permite analizar el ciclo de vida académica de los estudiantes de la Universidad y obtener la información de los procesos de enseñanza y aprendizaje.',
      },
      {
        Q: '¿Cómo funciona?',
        A: 'Podríamos decir que Aprendizaje Aumentado es el interlocutor entre los datos y la comprensión de los mismos, se compone de distintas aplicaciones:<br><b>ETL:</b> aplicación que se conecta a las bases de datos de las soluciones digitales de UTEC y extrae datos en forma periódica, los normaliza y carga en un único lugar (Data Lake).<br><b>Data Lake:</b> unifica los datos, facilita el cruce de información entre distintas fuentes y es donde se ejecutan las consultas base para la visualización de datos.<br><b>Visualización de Datos:</b> la interfaz de comunicación donde usuarios (docentes, colaboradores, estudiantes), visualizan e interactuan con los datos disponibles, recibe el nombre de Aprendizaje Aumentado.',
      },
      {
        Q: '¿Cómo se visualizan los datos?',
        A: 'Por defecto la solución muestra los datos del año actual, podrás utilizar el filtro Año para ver información de otros períodos. Debes tener en cuenta que en algunos casos no habrá datos para algunas carreras o programas, esto puede deberse a que en ese período la carrera aún no había sido creada,  ejemplo en el 2014 había dos carreras y un solo programa, por lo que solo podrás ver información de estos.',
      },
      {
        Q: '¿Por qué algunas gráficas no tienen datos?',
        A: 'Que en la serie de una gráfica aparezca en gris, con la referencia No hay datos puede deberse a:<br><ul><li>No se generaron datos para el período seleccionado</li><li>Los datos no están almacenados en la base de datos de origen.</li><li>El extractor de datos aún no ha actualizado la información.</li></ul>Si estás seguro que deberían existir datos para la carrera o unidad curricular para el período seleccionado envianos un mail a <a href="mailto:tecnologia.aprendizaje@utec.edu.uy">tecnologia.aprendizaje@utec.edu.uy</a>',
      },
      {
        Q: '¿Con qué frecuencia se actualiza la información que se muestra en la plataforma?',
        A: 'La información se actualiza dependiendo de la cantidad de datos que se fueron generando. Los datos que se encuentran alojados en registros más grandes pueden demorar hasta un mes en verse reflejados en la plataforma.',
      },
      {
        Q: 'Sobre la información que se muestra en la plataforma',
        A: 'La información que se muestra en la plataforma contiene datos personales de los estudiantes, por lo que su uso es exclusivo para fines académicos bajo la responsabilidad de cada usuario.',
      },
    ],
  },
  {
    name: 'Estudiantes',
    code: 'estudiantes',
    questions: [
      {
        Q: '¿Quiénes son estudiantes regulares?',
        A: 'Se entiende por estudiante regular, a todos los admitidos a las Carreras, que se hayan matriculado y se encuentren cursando el nivel correspondiente.',
      },
      {
        Q: '¿Cuáles son los tipos de calificaciones?',
        A: '<b>Calificación por unidad curricular:</b> En cada unidad curricular el estudiante deberá ser calificado obligatoriamente al menos en dos oportunidades durante el período académico de acuerdo al Sistema de Calificación establecido por el docente. En aquellas unidades curriculares que se impartan en un mismo período en más de un grupo de clase, los docentes deberán evaluar y calificar con los mismos estándares y rúbricas.<br><b>Calificación final:</b>La calificación final de una unidad curricular obedecerá a la situación académica en la que se encuentre el estudiante:<br><b class=sub>a)</b> Cuando la calificación del curso de una unidad curricular sea igual a 1, siendo esa su calificación final; si fuera superior a 1 e inferior a 2 en la calificación final será:<br><b>i.</b> La obtenida en el curso, en caso de optar por recursar.<br><b>ii.</b> La obtenida en el examen único, en caso de optar por esta segunda opción.<br><b class=sub>b)</b> Cuando la calificación del curso sea igual a 2, el estudiante deberá participar y aprobar una tutoría. De aprobar la tutoría, la misma se calificará con un 3 lo que le permitirá acceder al examen reglamentado. La calificación final en este caso será el 70% el 3 obtenido en la tutoría y el 30% de la calificación del examen reglamentado.<br><b class=sub>c)</b> Si la calificación del curso es igual a 3 el estudiante deberá rendir el examen reglamentado. La calificación final de la unidad curricular se compone de:<br><span style="margin-left:2em"><b>i.</b> Las calificaciones obtenidas a lo largo del curso que representan el setenta porciento de la calificación final.</span><br><span style="margin-left:2em"><b>ii.</b> La calificación del examen reglamentado que representa el treinta por ciento de la calificación final.<br><b class=sub>d)</b> Si la calificación del curso es igual o superior a 4, el estudiante exonera el examen final quedando dicha calificación del curso como calificación final de la unidad curricular.</span>',
      },
      {
        Q: '¿Qué niveles de calificación se utilizan?',
        A: 'Las calificaciones se expresan a través de una escala conceptual y numérica. Los niveles de calificación en todas las carreras UTEC son:<br><b class=sub>a) </b><span class=underlined>Excelente (5):</span> Es el nivel avanzado de saberes y competencias requeridos. Implica el dominio de los saberes y competencias sin asistencia docente directa, en forma autónoma y precisa. El estudiante es competente para agregar valor al resultado a través de la innovación, el desarrollo y la aplicación de contenidos que no fueron expresamente desarrollados en el curso.<br><b class=sub>b) </b><span class=underlined>Muy Bueno (4):</span> Es el nivel medio de dominio de saberes y competencias requeridos. Implica el dominio de los saberes y competencias, sin errores ni observaciones, con autonomía relativa, requiriendo aún alguna asistencia y orientación por parte del docente.<br><b class=sub>c) </b><span class=underlined>Suficiente (3):</span> Es el nivel básico de dominio de saberes y competencias requeridos, implica un nivel de errores o imprecisiones que no afectan radicalmente el desempeño con respecto a los objetivos de aprendizaje.<br><b class=sub>d) </b><span class=underlined>Insuficiente (2):</span> Es el nivel insuficiente de dominio de saberes y competencias requeridos. Implica un elevado nivel de errores en el resultado final que afecta alguna de las dimensiones evaluadas. Se considera necesario un trabajo suplementario para superar y corregir las deficiencias.<br><b class=sub>e) </b><span class=underlined>Deficiente (1):</span> En este nivel se ubican aquellos casos donde no hay ninguna evidencia del aprendizaje correspondiente a la dimensión que se está evaluando.',
      },
      {
        Q: '¿Qué tipos de créditos existen?',
        A: '<span class=underlined>Créditos Obligatorios:</span> Son aquellos en los que no existe la posibilidad de elección u opción por parte de los estudiantes.<br><span class=underlined>Créditos Optativos: </span>Son aquellos que están comprendidos como tal en el Plan de Estudios de una carrera. La apertura de unidades curriculares que genere créditos optativos será determinada discrecionalmente por la Universidad y estará sujeta a la decisión del CDC<br><span class=underlined>Créditos de libre elección: </span>Son aquellos que el estudiante puede elegir libremente:<br><b class=sub>i. </b>fuera del Plan de Estudios, establecidos o avalados por la propia Universidad;<br><b class=sub>ii. </b>dentro del Plan de Estudios, como actividades dentro del eje “Integración y Profesionalización”.',
      },
      {
        Q: '¿Qué es un egresado?',
        A: 'Estudiante que hubiere cumplido las instancias de formación y evaluación previstas en el “Reglamento General de Estudios” y en la resolución del “Plan de Estudios” al que esté asociado.',
      },
      {
        Q: '¿Qué son las desvinculaciones?',
        A: 'Son aquellos estudiantes que por dos períodos académicos consecutivos no se matricularon en las unidades curriculares, ni registraron actividad académica y tampoco formalizaron la solicitud de suspensión de estudios.',
      },
      {
        Q: '¿Cuáles son los tipos de desvinculaciones?',
        A: 'La desvinculación puede darse en diferentes momentos de la trayectoria educativa, dando lugar a las siguientes situaciones:<br><b class=sub>a)</b><span class=underlined> Desvinculación pre inicial:</span> es el estudiante que luego de ser admitido a una Carrera se matricula a las unidades curriculares del primer Período Académico, pero no inicia ni registra actividad académica en dichos cursos.<br><b class=sub>b)</b><span class=underlined> Desvinculación inicial:</span> es el estudiante que abandona sus estudios, formal o tácitamente, dentro del primer semestre de la Carrera.<br><b class=sub>c)</b><span class=underlined> Desvinculación temprana:</span> es el estudiante que abandona sus estudios, formal o tácitamente, antes de la primera mitad de su Carrera.<br><b class=sub>d)</b><span class=underlined>Desvinculación tardía:</span>es el estudiante que abandona sus estudios, formal o tácitamente, luego de la primera mitad de su Carrera.',
      },
    ],
  },
  {
    name: 'Actividad Digital',
    code: 'actividad_digital',
    questions: [
      {
        Q: '¿Qué es EDU?',
        A: 'EDU es el entorno de Educación Digital Universitaria de cursos masivos abiertos en línea desarrollado por la Universidad Tecnológica del Uruguay. Ofrece cursos gratis, con certificaciones verificadas que demuestran que has finalizado con el curso y que has adquirido conocimientos y habilidades que te permiten avanzar en tu carrera profesional.',
      },
      {
        Q: '¿Qué es MOODLE?',
        A: 'Es el entorno virtual de aprendizaje donde los estudiantes tienen acceso a medios digitales y recursos proporcionados por los docentes de las distintas unidades curriculares, así como un contacto directo y personalizado con los encargados del curso, proporcionando también un registro detallado de la actividad académica de cada estudiante.',
      },
      {
        Q: '¿Qué  son los módulos de Moodle?',
        A: `Moodle agrupa en módulos las actividades y recursos que se realizan en un curso, a su vez dentro de estas hay distintos tipos de objetos, ejemplo:<br><b>Recursos:</b> archivos, carpetas, etiquetas, libro, página, paquete de contenido IMS o una dirección web (URL)<br><b>Actividades:</b> tareas, chat, lecciones, bases de datos, retroalimentación, foros, glosario, lección, herramienta externa, cuestionario.<br>Visita este sitio web para profundizar en estos <a href="https://docs.moodle.org/all/es/Gestionando_un_curso_Moodle">conceptos.</a><br><br>¿Cuáles son los distintos tipos de modulos en Moodle?<table class="referencias"><tbody><tr><td><img alt="tarea" src=${tarea}></td><td>Assignment</td><td>Tarea</td></tr><tr><td><img alt="libro" src=${libro}></td><td>Book</td><td>Libro</td></tr><tr><td><img alt="chat" src=${chat}></td><td>Chat</td><td>Chat</td></tr><tr><td><img alt="consulta" src=${consulta}></td><td>Choice</td><td>Consulta</td></tr><tr><td><img alt="base_de_datos" src=${base_de_datos}></td><td>Data</td><td>Base de datos</td></tr><tr><td><img alt="encuesta" src=${encuesta}></td><td>Feedback</td><td>Encuesta</td></tr><tr><td><img alt="carpeta" src=${carpeta}></td><td>Folder</td><td>Carpeta</td></tr><tr><td><img alt="foro" src=${foro}></td><td>Forum</td><td>Foro</td></tr><tr><td><img alt="glosario" src=${glosario}></td><td>Glossary</td><td>Glosario</td></tr><tr><td><img alt="paquete_de_contenido_ims" src=${paquete_de_contenido_ims}></td><td>Imscp</td><td>Paquete de contenido IMS</td></tr><tr><td><img alt="etiqueta" src=${etiqueta}></td><td>Label</td><td>Etiqueta</td></tr><tr><td><img alt="leccion" src=${leccion}></td><td>Lesson</td><td>Lecci&oacute;n</td></tr><tr><td><img alt="herramienta_externa" src=${herramienta_externa}></td><td>Lti</td><td>Herramienta externa</td></tr><tr><td><img alt="pagina" src=${pagina}></td><td>Page</td><td>P&aacute;gina</td></tr><tr><td><img alt="cuestionario" src=${cuestionario}></td><td>Quiz</td><td>Cuestionario</td></tr><tr><td><img alt="archivo" src=${archivo}></td><td>Resource</td><td>Archivo</td></tr><tr><td><img alt="base_de_datos" src=${base_de_datos}></td><td>Data</td><td>Base de datos</td></tr><tr><td><img alt="paquete_scorm" src=${paquete_scorm}></td><td>SCORM</td><td>Paquete SCORM</td></tr><tr><td><img alt="encuesta" src=${encuesta}></td><td>Survey</td><td>Encuesta</td></tr><tr><td><img alt="url" src=${url}></td><td>URL</td><td>URL</td></tr><tr><td><img alt="wiki" src=${wiki}></td><td>Wiki</td><td>Wiki</td></tr><tr><td><img alt="taller" src=${taller}></td><td>Workshop</td><td>Taller</td></tr><tr><td><img alt="asistencia" src=${asistencia}></td><td>Attendance</td><td>Asistencia</td></tr><tr><td><img alt="reserva" src=${reserva}></td><td>Reservatio</td><td>Reserva</td></tr><tr><td><img alt="lista_de_verificacion" src=${lista_de_verificacion}></td><td>Checklist</td><td>Lista de verificaci&oacute;n</td></tr><tr><td><img alt="reserva_2" src=${reserva_2}></td><td>booking</td><td>Reserva</td></tr><tr><td><img alt="h5p" src=${h5p}></td><td>Hvp</td><td>H5P</td></tr><tr><td><img alt="encuesta_2" src=${encuesta_2}></td><td>Questionnaire</td><td>Encuesta</td></tr><tr><td><img alt="eleccion_de_grupo" src=${eleccion_de_grupo}></td><td>Choicegroup</td><td>Elecci&oacute;n de grupo</td></tr></tbody></table>`,
      },
    ],
  },
  {
    name: 'Postulaciones',
    code: 'postulaciones',
    questions: [
      {
        Q: '¿Qué son las postulaciones?',
        A: 'La incorporación de un estudiante a UTEC se inicia con un proceso de admisión a la Carrera seleccionada y posterior matriculación a las unidades curriculares del nivel correspondiente. Este proceso se regulará anualmente, debiendo contemplarse aspectos tales como el cupo y los requisitos de postulación por Carrera.',
      },
      {
        Q: '¿Cuáles son los requisitos para las postulaciones?',
        A: '<b>    a)</b> Tener aprobada la Educación Media Superior en la orientación exigida por cada Carrera o estar comprendido en algunas de las previsiones del artículo 4 del Reglamento General de Estudios.<br><b)</b> Cumplir lo establecido en el proceso general de admisión de cada Carrera.<br><b>c)</b> Matricularse a las unidades curriculares de la Carrera según lo establecido en el Art. 10 literal b, asumiendo la responsabilidad de cumplir con la carga de trabajo (presencial y autónoma), del Plan de Estudio.<br><b>d)</b> Cumplir con el Reglamento General de Estudios, Reglamento de Convivencia Estudiantil y otras normativas vinculantes.<br><b>e)</b> La admisión a una segunda Carrera estará sujeta al cumplimiento del artículo 10 del Reglamento General de Estudios. Esta situación de ninguna manera obliga a la Universidad a compatibilizar los horarios de la unidades curriculares de ambas Carreras.',
      },
    ],
  },
  {
    name: 'Perfil y Contexto',
    code: 'perfil_y_contexto',
    questions: [
      {
        Q: '¿De donde proviene la información de perfil y contexto?',
        A: 'La encuesta de seguimiento de estudiantes es uno de los instrumentos que permite generar y mantener actualizada información que permita a la institución monitorear los cambios de diversa índole respecto a la situación de partida de los estudiantes, y así  evaluar resultados e impactos de los programas de formación que vaya desarrollando.<br>Aprendizaje Aumentado extrae esta información, la normaliza y disponibiliza, en esta versión se muestra la información que está directamente relacionada con la tasa de abandono/desvinculación de los estudiantes.<br>Ten en cuenta que la encuesta tiene preguntas de seguimiento donde los estudiantes deben contestar todos los años (ej: Trabajas Si o No) y otras que las contesta una única vez (ejemplo: ¿Qué orientación seleccionaste en bachillerato? ).',
      },
    ],
  },
];
//   {
//     name: 'Probabilidad de abandono',
//     code: 'probabilidad_de_abandono',
//     questions: [
//       {
//         Q: '¿Qué significa probabilidad de abandono?',
//         A: 'Este indicador se obtiene teniendo en cuenta diversas variables que pueden representar dificultades para la continuidad de la trayectoria educativa del estudiante. Este indicador permite al docente contar con insumos para poder acompañar y apoyar los procesos de aprendizaje atendiendo la situación particular de cada estudiante.',
//       },
//       {
//         Q: '¿Cómo se calcula la probabilidad de abandono?',
//         A: 'La probabilidad de abandono se calcula utilizando una red neuronal que toma diferentes variables de cada estudiante (perfil, contexto, actividad en plataformas, entre otros). Una red neuronal aprende patrones en los datos históricos generados por los estudiantes, cuando le "mostramos" los datos de un estudiante, la red es capaz de predecir su probabilidad de abandono.',
//       },
//       {
//         Q: '¿Cómo identifico los niveles de probabilidad de abandono?',
//         A: 'Tanto en la sección de grupo como en las gráficas, las referencias de color de acuerdo al % de probabilidad son las siguientes:<br>% Bajo  (verde): entre 0% y 10% <br>% Medio  (amarillo): entre 10% y 50% <br>% Alto (naranja): entre 50% y 75%<br>% Muy Alto (rojo): mayor a 75%',
//       },
//     ],
//   },
// ];

const divHtmlStyle = {
  '@media (max-width: 400px)': {
    width: '200px',
    overflow: 'scroll',
  },
};

/**
 * Modal to render the first steps help
 * @component
 */
const FAQModal = () => {
  const [search, setSearch] = useState('');
  const [opened, setOpened] = useState<string[]>(['']);
  const buttonName = 'Preguntas frecuentes';

  const handleChange =
    (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
      setOpened((prevState) => {
        let result = [...prevState];
        if (isExpanded) {
          result.push(panel);
        } else {
          result = result.filter((x) => x !== panel);
        }
        return result;
      });
    };

  let filteredFaqs: IFAQData[] = JSON.parse(JSON.stringify(ListOfFaQs));
  if (search.length > 0) {
    let result: IFAQData[] = [];
    ListOfFaQs.forEach((faq: IFAQData) => {
      result.push({
        ...faq,
        questions: faq.questions.filter((question: IFAQ) => {
          const standarizedSearch = standarizeString(search);

          const included =
            standarizeString(question.Q).includes(standarizedSearch) ||
            standarizeString(question.A).includes(standarizedSearch);

          return included;
        }),
      });
    });

    filteredFaqs = JSON.parse(JSON.stringify(result));
  }
  return (
    <BasicModal
      title="Preguntas frecuentes"
      description=""
      buttonTitle={buttonName}
    >
      <div
        style={{
          maxHeight: '500px',
          maxWidth: '760px',
        }}
      >
        <Grid item mb={1} xs={12} style={{ textAlign: 'right' }}>
          <SearchInput searchPlaceholder={'Buscar'} setSearchBar={setSearch} />
        </Grid>
        <div
          style={{
            maxHeight: '420px',
            overflowX: 'hidden',
            overflowY: 'scroll',
          }}
        >
          {filteredFaqs.map((faq: IFAQData, index: number) => {
            return faq.questions.length > 0 ? (
              <Accordion
                key={`${faq.code}_${index}`}
                expanded={opened.includes(faq.code)}
                onChange={handleChange(faq.code)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography
                    sx={{
                      flexShrink: 0,
                      color: '#000',
                      fontWeight: '500',
                      lineHeight: '1.2',
                      fontFamily: 'heavy',
                    }}
                  >
                    {faq.name}
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  {faq.questions.map((question: IFAQ, innerIndex: number) => {
                    return (
                      <Accordion
                        key={`${faq.code}_${index}_${innerIndex}`}
                        expanded={opened.includes(
                          `${faq.code}_${index}_${innerIndex}`,
                        )}
                        onChange={handleChange(
                          `${faq.code}_${index}_${innerIndex}`,
                        )}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Typography
                            sx={{
                              flexShrink: 0,
                              color: opened.includes(
                                `${faq.code}_${index}_${innerIndex}`,
                              )
                                ? '#03b5d2'
                                : '#7288a2',
                              width: '100%',
                            }}
                          >
                            {question.Q}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={divHtmlStyle}>
                          <div
                            style={{ color: '#555' }}
                            dangerouslySetInnerHTML={{ __html: question.A }}
                          />
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            ) : null;
          })}
        </div>
      </div>
    </BasicModal>
  );
};

export default FAQModal;
